$(function() {
  //app download popup
  $('.app-download-sms-link').click(function(e){
      e.preventDefault();
      var deviceType = $(this).data('deviceType');
      $.modal({
          url : "/r/dialog/AppDownload.jsp?deviceType=" + $(this).data('deviceType'),
          triggerOpen: true,
          type: "small",
          returnFocus: '#' + deviceType,
          onComplete: function() {
            $( ".js-accordion" ).accordion();
          }
      });
  });

  /*
  * Accessibility - add aria-current="page" to active navigation link
  */
  if($('.js-left-nav-container')[0]) {
    var lastActiveItem = $('.js-left-nav-container a.active:last');
    lastActiveItem.attr('aria-current', 'page');
  }
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js